import {Dispatch} from "redux";
import {addAlert, AlertType} from "@web2/ap-alerts";
import {apiLink} from "@web2/ap-api-routes";
import {appendQueryString, catch400, IQueryValue, parseSearch} from "@web2/ap-request";
import {createRequestActionTypes} from "@web2/ap-request-state";

import {getAuthorizedRequest} from "../../app/utils/authorized_request";

const APPLICATIONS_LIST_FETCH = "applications_list/FETCH";
export const applicationsListFetchActionTypes = createRequestActionTypes(APPLICATIONS_LIST_FETCH);

export const error400Message = "Proszę poprawić błędy zaznaczone w formularzu.";

export function getApplicationList(queryObj: Record<string, IQueryValue>) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: applicationsListFetchActionTypes.start,
            latestQuery: parseSearch(window.location.search)
        });

        const applicationListApiLink = appendQueryString(apiLink.applications.list({})(null), queryObj);

        return getAuthorizedRequest(applicationListApiLink)
            .then((response) => {
                const result = {
                    list: response,
                    count: response.length
                };
                dispatch({type: applicationsListFetchActionTypes.success, result});
                return response;
            })
            .catch(
                catch400((responseError) => {
                    dispatch({
                        type: applicationsListFetchActionTypes.error,
                        error: responseError.appError
                    });
                    dispatch(addAlert({type: AlertType.ERROR, text: error400Message}, 5000));
                })
            );
    };
}

export const resetApplicationList = () => ({type: applicationsListFetchActionTypes.reset});
